export default __webpack_public_path__ + "static/media/balance-records.54c787dd.png";